export default {
  data() {
    return {
      initialPageYOffset: 0
    };
  },

  methods: {
    handleScroll() {
      window.scrollTo(0, this.initialPageYOffset);
    },

    disableWindowScroll() {
      if (this.isMobile()) {
        window.document.querySelector('body').style.overflow = 'hidden';
        return;
      }

      this.initialPageYOffset = window.pageYOffset;
      window.addEventListener('scroll', this.handleScroll, false);
    },

    enableWindowScroll() {
      window.document.querySelector('body').style.overflow = '';
      window.removeEventListener('scroll', this.handleScroll, false);
    }

  }
};